import React from 'react';
import { useTranslation } from 'react-i18next';
import './CustomCheckbox.css';

const CustomCheckbox = ({ handleChange, defaultValue }) => {
  const { t } = useTranslation();

  return (
    <label className="checkbox-container">
      {t('remember_address')}
      <input
        type="checkbox"
        className="custom-checkbox"
        onChange={handleChange}
        checked={defaultValue}
      />
      <span className="checkmark" />
    </label>
  );
};

export const Checkbox = (props) => {
  const { t } = useTranslation();

  return (
    <label className="checkbox-container">
      {t('remember_address')}
      <input type="checkbox" className="custom-checkbox" {...props} />
      <span className="checkmark"></span>
    </label>
  );
};

export default CustomCheckbox;
